var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "services-modal default-modal" },
    [
      _c(
        "button",
        {
          staticClass: "default-modal__close",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("closeAll")
            },
          },
        },
        [_c("IconComponent", { attrs: { name: "close" } })],
        1
      ),
      _c("ImgComponent", { attrs: { head_img: _vm.data.img } }),
      _c(
        "form",
        {
          staticClass: "default-modal__body services-modal__body",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
            },
          },
        },
        [
          _c("span", { staticClass: "services-modal__title" }, [
            _vm._v(_vm._s(_vm.data.title)),
          ]),
          _c("span", { staticClass: "services-modal__description" }, [
            _vm._v(_vm._s(_vm.data.description)),
          ]),
          _c("h4", { staticClass: "services-modal__subtitle" }, [
            _vm._v("Оставьте заявку"),
          ]),
          _c("InputComponent", {
            attrs: {
              errors: _vm.form.phone.errors,
              placeholder: "номер телефона",
              mask: "+7 (###) ###-##-##",
            },
            model: {
              value: _vm.form.phone.value,
              callback: function ($$v) {
                _vm.$set(_vm.form.phone, "value", $$v)
              },
              expression: "form.phone.value",
            },
          }),
          _c(
            "button",
            {
              staticClass: "btn btn--black btn--md",
              on: { click: _vm.submit },
            },
            [
              _vm.loading
                ? _c("IconComponent", { attrs: { name: "loading" } })
                : _c("span", [_vm._v(" Отправить ")]),
            ],
            1
          ),
          _c(
            "span",
            { staticClass: "default-modal__documents" },
            [
              _vm._v("\n      Нажимая на кнопку, вы соглашаетесь с\n      "),
              _c(
                "router-link",
                {
                  attrs: {
                    to: { name: "about", params: { link: "termsOfUse" } },
                  },
                },
                [_vm._v("\n        условиями использования\n      ")]
              ),
              _vm._v("\n      и\n      "),
              _c(
                "router-link",
                {
                  attrs: {
                    to: { name: "about", params: { link: "publicOffer" } },
                  },
                },
                [_vm._v("\n        публичной офертой\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }